import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { EntityMembershipPolicies } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const MEMBERSHIP_POLICIES_QUERY_KEY = "membership-policies";
export const keyFn = (entityId, entityType) => [MEMBERSHIP_POLICIES_QUERY_KEY, entityType, entityId];
export const fetchMembershipPolicies = async (entityId, entityType) => EntityMembershipPolicies.getByInitiatorId(entityType, entityId);
const useEntityMembershiPolicies = (entityId, entityType, { enabled } = { enabled: true }) => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: keyFn(entityId, entityType),
    queryFn: () => defaultOnError(
      fetchMembershipPolicies(entityId, entityType),
      i18n.t("notifications.fetch_entity_membership_policies_failed", { ns: "enterprise_collections" }),
      i18n.t("notifications.fetch_entity_membership_policies_failed_title", { ns: "enterprise_collections" })
    ),
    enabled
  });
  return {
    data: data != null ? data : null,
    isLoading: isFetching,
    refetch
  };
};
export default useEntityMembershiPolicies;
